import { listClasses } from '@mui/material/List';
import { type Components, type Theme } from '@mui/material/styles';

import getStyleQuery from '../../../utils/tools/getStyleQuery';
import { paper } from '../../css';

// ----------------------------------------------------------------------

export function popover(theme: Theme): Components<Theme> {
    return {
        MuiPopover: {
            styleOverrides: {
                paper: {
                    [getStyleQuery()]: {
                        ...paper({ theme, dropdown: true }),
                        [`& .${listClasses.root}`]: {
                            padding: 0,
                        },
                    },
                },
            },
        },
    };
}
